import { render, staticRenderFns } from "./CartInfoIcon.vue?vue&type=template&id=4ff19d55&scoped=true"
import script from "./CartInfoIcon.vue?vue&type=script&lang=js"
export * from "./CartInfoIcon.vue?vue&type=script&lang=js"
import style0 from "./CartInfoIcon.vue?vue&type=style&index=0&id=4ff19d55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff19d55",
  null
  
)

export default component.exports